/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, {useEffect, useState} from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { gsap } from "gsap";
// import ReactFluidScroll from 'react-fluid-scroll';
import WayfxTransition from "./transition"
import 'normalize.css';
import "../scss/app.scss"

import SiteHeader from "./SiteHeader"
import Footer from "./Footer";

function debounce(fn, ms) {
  let timer;
  return () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      fn.apply(this, arguments);
    }, ms);
  };
}

const Layout = ({ children, location }) => {

  /*
    Auto updating window dimensions on resize
    See Kevin's notes for what each does below
  */

  // define dimension variables for use in hook
  let height;
  let width;

  // Check for the window element. 
  // Needed for server size rendering of Gatsby else use of window.innerHeight/Width will cause build failures.
  if (typeof window !== `undefined`) {
    height = window.innerHeight
    width = window.innerWidth
  }

  // See default state of dimensions
  const [dimensions, setDimensions] = useState({
    windowHeight: height,
    windowWidth: width,
  })

  // Use hook to run the following code after page is loaded
  useEffect(() => {

    /*
      Debounce function for performance to check window resizing every 1000ms instead of of every ms. 
      Upon resize, set new dimension to state.
      Update 1000 value as needed. Note: 1000 = 1 second
    */
    const debouncedHandleResize = debounce(function handleResize() {
      setDimensions({
        windowHeight: window.innerHeight,
        windowWidth: window.innerWidth,
      });
    }, 1000);

    // Listen for window resize and run the debounce resize function above.
    window.addEventListener(`resize`, debouncedHandleResize)

    // Remove the event listener if resizing stopped.
    return () => window.removeEventListener(`resize`, debouncedHandleResize)
    
  }, [])

  /*
    Cool trick to set proper vieweport height, so it uses the browser window's innerHeight.
    Useful for on mobile browsers like Safari where URL bar and bar at the bottom hides viewport elements when using the 'vh' property in css
    This will set a css custom property to the :root element called --vh
    To use in css/sass, set a fallback height then use height with custom property
    
    Example: 
    
    height: 85vh;
    height: calc(var(--vh, 1vh) * 85);

    The second height property will get the value of --vh set on page load and multiply it by the #vh you want. This will ensure it's actually
    85vh in the window.
  */
  useEffect(() => {
    let vh = dimensions.windowHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  }, [dimensions.windowHeight]);


  // prevents flashing
  useEffect(() => {
    gsap.to("body", 0, { css: { visibility: "visible" } });
  });

  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
        <WayfxTransition location={location}>
          <SiteHeader siteTitle={data.site.siteMetadata.title} location={location}></SiteHeader>
        {/* <ReactFluidScroll viscosity={0.2}> */}
          <main>{children}</main>
          <Footer />
        {/* </ReactFluidScroll> */}
        </WayfxTransition>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
